import React, { useState, useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import { FormPreferences } from '../../containers';
import useStyles from './index.style';
import StateRoomBanner from '../../components/StateRoomBanner';
import NotificationBannerComponent from '../../components/NotificationBanner';
import useCommonStyles from '../../commons/useCommonStyles';

const Preferences = (props) => {
  const css = useStyles();
  const styles = useCommonStyles();
  const [propNotification, setNotification] = useState({
    title: '',
    description: '',
    icon: '',
    type: '',
    open: false,
  });
  const { primaryBooking } = props;
  useEffect(() => {
    if (propNotification.open) {
      document.querySelector('.contentDialog').scrollTo(0, 0);
    }
  }, [propNotification]);

  const notification = () =>
    propNotification.open && (
      <div className={`${css.notificationContainer} ${styles.notification}`}>
        <NotificationBannerComponent
          {...propNotification}
          renderCloseBtn
          isBannerOpen
          onClose={() => setNotification({ open: false })}>
          <div>
            {/* this children will only render when useSlot comes as true for reprice notification */}
            {propNotification.description}{' '}
            <a href={`tel:${propNotification.linkLabel}`} target="_blank" rel="noopener noreferrer">
              {propNotification.linkLabel}
            </a>
          </div>
        </NotificationBannerComponent>
      </div>
    );

  return (
    <div className={`${css.root}  ${isIOS ? 'iOS' : ''}`}>
      <StateRoomBanner primaryBooking={primaryBooking} notification={notification()} />
      <FormPreferences {...props} setNotification={setNotification} />
    </div>
  );
};

export default Preferences;
